import { render, staticRenderFns } from "./UpdateUserRoleModal.vue?vue&type=template&id=bb03a73a&scoped=true&"
import script from "./UpdateUserRoleModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUserRoleModal.vue?vue&type=style&index=0&id=bb03a73a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb03a73a",
  null
  
)

export default component.exports